import React from 'react'
import { Link } from 'react-router-dom'
import { Menu, Plus } from 'lucide-react'
import { useCreditsQuery } from '../hooks/useCreditsQuery'
import { SHORT_LOGO_URL, SHORT_MARK_URL } from '../lib/brandAssets'

interface TopBarProps {
  /** モバイル(767px 以下)のドロワーを開く */
  onOpenMenu: () => void
  menuOpen: boolean
}

/**
 * 全アプリ共通のトップバー（family-design: 高さ 56px・白・下線 1px）。
 * 左: アプリのロゴ / 右: 残高（常時表示）・クレジットを追加・アバター。
 */
export const TopBar: React.FC<TopBarProps> = ({ onOpenMenu, menuOpen }) => {
  const { data, isLoading, isError } = useCreditsQuery()

  // 残高は Account 画面と同じ displayBalance（取得失敗は 0 と区別して「—」）
  const balance = data?.displayBalance
  const balanceText =
    typeof balance === 'number' ? Math.floor(balance).toLocaleString('ja-JP') : isLoading ? '…' : '—'
  const balanceUnavailable = typeof balance !== 'number' && !isLoading

  return (
    <header
      className="gm-topbar fixed inset-x-0 top-0 z-40"
      // 固定バーの下をスクロールする内容が透けないよう、真珠色の地(gm-shell と同じ固定背景)を敷く
      style={{ background: 'var(--gm-shell-bg)', backgroundAttachment: 'fixed' }}
    >
      <button
        type="button"
        className="gm-icon-btn -ml-2 md:hidden"
        onClick={onOpenMenu}
        aria-label="メニューを開く"
        aria-expanded={menuOpen}
        aria-controls="app-sidebar"
      >
        <Menu size={20} aria-hidden="true" />
      </button>

      <Link to="/projects" className="gm-topbar-logo" aria-label="Genemo Short ホーム">
        {/* 640px 未満ではマークだけ */}
        <img src={SHORT_MARK_URL} alt="" className="sm:!hidden" />
        <img src={SHORT_LOGO_URL} alt="Genemo Short" className="!hidden sm:!block" />
      </Link>

      <div className="gm-topbar-right">
        <Link
          to="/account"
          className="gm-balance"
          aria-label={balanceUnavailable ? '残高を取得できませんでした。アカウント画面を開く' : `残高 ${balanceText} クレジット。アカウント画面を開く`}
          title={isError ? '残高を取得できませんでした' : undefined}
        >
          <span className="gm-balance-label hidden sm:inline">残高</span>
          <span className="gm-balance-num">{balanceText}</span>
          <span className="gm-balance-unit">cr</span>
        </Link>

        <Link to="/account" className="gm-btn gm-btn-primary gm-btn-pill hidden sm:inline-flex">
          <Plus size={16} aria-hidden="true" />
          クレジットを追加
        </Link>
      </div>
    </header>
  )
}

export default TopBar
